import * as React from 'react';

const PayPal = (props: React.ComponentProps<'svg'>) => (
  <svg
    viewBox="0 0 58 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" fill="white" />
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" stroke="#E5E7EB" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.357 30.7471L24.7248 28.3319L23.9054 28.3122H19.9921L22.7117 10.4895C22.7202 10.4355 22.7475 10.3854 22.7875 10.3497C22.8277 10.3141 22.879 10.2946 22.9326 10.2946H29.5309C31.7216 10.2946 33.2333 10.7656 34.0224 11.6955C34.3924 12.1318 34.6281 12.5877 34.7422 13.0894C34.8618 13.6158 34.8638 14.2447 34.7471 15.0119L34.7386 15.0677V15.5593L35.1087 15.776C35.4202 15.9469 35.6679 16.1424 35.8578 16.3662C36.1743 16.7393 36.379 17.2134 36.4655 17.7753C36.555 18.3533 36.5254 19.0413 36.379 19.82C36.2101 20.7157 35.9372 21.4959 35.5686 22.1342C35.2297 22.7224 34.7978 23.2103 34.2849 23.5883C33.7952 23.9476 33.2135 24.2203 32.5558 24.3948C31.9184 24.5663 31.1917 24.6528 30.3947 24.6528H29.8812C29.5141 24.6528 29.1575 24.7895 28.8775 25.0345C28.5967 25.2846 28.4111 25.6263 28.3541 26L28.3153 26.2175L27.6653 30.4746L27.6359 30.6308C27.628 30.6803 27.6146 30.7049 27.5949 30.7216C27.5774 30.7369 27.5522 30.7471 27.5275 30.7471H24.357"
      fill="#28356A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.4594 15.1245C35.4399 15.2546 35.4172 15.3876 35.392 15.5243C34.5219 20.142 31.5448 21.7373 27.7427 21.7373H25.8068C25.3418 21.7373 24.9498 22.0861 24.8775 22.5603L23.6056 30.899C23.5585 31.2104 23.7907 31.4909 24.0945 31.4909H27.5281C27.9346 31.4909 28.28 31.1856 28.3441 30.7711L28.3778 30.5909L29.0243 26.3505L29.0658 26.118C29.1291 25.7021 29.4753 25.3966 29.8818 25.3966H30.3953C33.7219 25.3966 36.3262 24.0007 37.0874 19.961C37.4052 18.2735 37.2407 16.8644 36.3993 15.8734C36.1447 15.5746 35.8289 15.3265 35.4594 15.1245"
      fill="#298FC2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.5487 14.7494C34.4157 14.7093 34.2786 14.6731 34.1379 14.6403C33.9964 14.6083 33.8516 14.58 33.7024 14.5551C33.1805 14.468 32.6085 14.4266 31.9959 14.4266H26.8241C26.6967 14.4266 26.5757 14.4564 26.4675 14.5101C26.2289 14.6287 26.0517 14.8621 26.0088 15.1478L24.9085 22.3503L24.877 22.5603C24.9493 22.0862 25.3412 21.7373 25.8062 21.7373H27.7422C31.5442 21.7373 34.5213 20.1413 35.3915 15.5244C35.4175 15.3877 35.4393 15.2547 35.4589 15.1246C35.2388 15.0038 35.0003 14.9005 34.7436 14.8126C34.6801 14.7908 34.6147 14.7698 34.5487 14.7494"
      fill="#22284F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.0091 15.1478C26.052 14.8621 26.2292 14.6287 26.4678 14.5109C26.5768 14.457 26.697 14.4272 26.8244 14.4272H31.9962C32.6088 14.4272 33.1808 14.4688 33.7027 14.556C33.8519 14.5806 33.9967 14.6091 34.1382 14.6411C34.2789 14.6737 34.416 14.7101 34.549 14.75C34.615 14.7704 34.6804 14.7916 34.7445 14.8126C35.0012 14.9005 35.2398 15.0046 35.4599 15.1246C35.7189 13.4181 35.4578 12.2563 34.5652 11.2042C33.581 10.0458 31.8048 9.55005 29.532 9.55005H22.9335C22.4693 9.55005 22.0732 9.89891 22.0015 10.3738L19.2532 28.3798C19.199 28.736 19.4648 29.0574 19.8124 29.0574H23.886L26.0091 15.1478"
      fill="#28356A"
    />
  </svg>
);

export default PayPal;
